import store from '../store';
import {baseURL} from '../service/requests';
import userImg from '../img/ico/user.svg';

export const getNativeLang = (lang) => {
   const state = store.getState();
   const languages = state.languages.languages;

    if(lang) {
        const currentLang = languages.find((x) => x.code === lang);
        if(currentLang) {
           return currentLang
        } else {
           return null
        }
     }
}

export const getUserPhoto = (imagePath) => {
   if (imagePath) {
      if (imagePath.includes("http") || imagePath.includes("https")) {
         return imagePath;
      } else {
         return `${baseURL}images/users/${imagePath}`;
      }
   } else {
      return userImg;
   }
};